import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { Text } from '@cinesend/ui-kit'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import QueryState from '../../components/query_state'
import useStore from '../../hooks/use_store'
import ActivityLogsTable from '../../components/activity_logs_table'
import Profile from './profile'
import Security from './security'
import SettingsCard from '../../components/settings_card'

const ParkingLot = () => (
  <SettingsCard>
    <Text variant='sm'>Parking lot - coming soon.</Text>
  </SettingsCard>
)

export default function Account() {
  const { data: user, isLoading } = useQuery(['/user'])
  const { updateModel } = useStore()
  const queryClient = useQueryClient()
  const updateUser = (data) => {
    updateModel.mutate(
      { endpoint: 'users', id: user.id, data },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(['/user'])
        },
      }
    )
  }
  const { pathname } = useLocation()
  const isActivityLogs = pathname.endsWith('/activity-logs')
  const title = pathname.endsWith('/security')
    ? 'Security'
    : isActivityLogs
      ? 'Activity Logs'
      : pathname.endsWith('/organization')
        ? 'Organization'
        : pathname.endsWith('/members')
          ? 'Members'
          : 'Profile'

  return (
    <QueryState isLoading={isLoading} loadingClassName='min-h-screen'>
      <div className={`mx-auto flex w-full flex-col gap-12 ${isActivityLogs ? '' : 'max-w-3xl'}`}>
        <Text as='h1' variant='4xl-semibold'>
          {title}
        </Text>
        <Routes>
          <Route exact path='' element={<Navigate to='profile' replace />} />
          <Route path='profile' element={<Profile user={user} updateUser={updateUser} />} />
          <Route path='security' element={<Security user={user} updateUser={updateUser} />} />
          <Route path='organization' element={<ParkingLot />} />
          <Route path='members' element={<ParkingLot />} />
          <Route
            path='activity-logs'
            element={
              <SettingsCard>
                <ActivityLogsTable queryKey={`causerID=${user.id}`} />
              </SettingsCard>
            }
          />
        </Routes>
      </div>
    </QueryState>
  )
}
